import React from 'react';
import PropTypes from 'prop-types';
import { get } from 'lodash';
import { css } from '@bd/bdui-styles/emotion';
import { SanitizeHtml, Image } from '@bd/bdcore-utilities';
import { colors, typography } from '../../../styles';

const styles = css`
  .PageTextSection {
    padding: 45px 0;
    position: relative;
    z-index: 2;
    @media (min-width: 992px) {
      padding: 90px 0;
    }
  }
  .PageTextSection_media {
    display: flex;
    justify-content: center;
    align-items: center;
    height: 100%;
    position: relative;
    z-index: 3;
  }
  .PageTextSection_image {
    width: 100%;
    margin: 0 0 45px 0;
  }
  .PageTextSection_content {
    display: flex;
    flex-direction: column;
    justify-content: center;
    height: 100%;
    padding: 0 10px;
    position: relative;
    z-index: 3;
    @media (min-width: 1200px) {
      padding: 0 45px;
    }
  }
  .PageTextSection_leadIn p {
    font-size: 24px;
    font-weight: 400;
    line-height: 1.6;
    color: ${colors.brand2};
    @media (min-width: 992px) {
      font-size: 32px;
    }
  }
  .PageTextSection_body {
    p {
      font-size: 18px;
      line-height: 1.8;
      font-weight: 300;
      @media (min-width: 992px) {
        font-size: 24px;
      }
    }
    ul {
      list-style: none;
      padding: 0;
      margin: 0 0 30px;
      text-align: center;
      li {
        padding: 10px 0 0 18px;
        margin: 0;
        font-family: ${typography.Condensed};
        position: relative;
        font-size: 18px;
        line-height: 1.8;
        font-weight: 300;
        @media (min-width: 992px) {
          width: 100%;
          padding: 10px 20px 10px 20px;
          font-size: 24px;
        }
        ${'' /* &::before {
          content: '';
          display: block;
          position: absolute;
          width: 8px;
          height: 8px;
          left: 0;
          top: 22px;
          background-color: ${colors.brand3};
          @media (min-width: 992px) {
            width: 10px;
            height: 10px;
            top: 25px;
          }
        } */}
      }
    }
    ol {
      padding: 0 0 0 15px;
      margin: 0 0 30px 0;
      li {
        margin: 0;
        font-family: ${typography.Condensed};
        position: relative;
        font-size: 18px;
        line-height: 1.8;
        font-weight: 300;
        @media (min-width: 992px) {
          font-size: 24px;
        }
      }
    }
`;

function PageTextSection({ content }) {
  return (
    <div>
      {
        (
          get(content, '[0].image.contentUrl')
          || get(content, '[0].lead_in')
          || get(content, '[0].body')
        ) &&
        <div className={styles}>
          <div className="PageTextSection">
            <div className="container">
              <div className="row">
                <div className="col-lg-8 mx-lg-auto">
                  {
                    get(content, '[0].image.contentUrl') &&
                    <div className="PageTextArea_media">
                      <Image
                        src={get(content, '[0].image.contentUrl')}
                        width={1200}
                        height={1200}
                        alt={get(content, '[0].image.name', get(content, '[0].image.caption', ''))}
                        className="PageTextSection_image"
                      />
                    </div>
                  }
                  {
                    get(content, '[0].lead_in') &&
                    <div className="PageTextSection_leadIn" dangerouslySetInnerHTML={SanitizeHtml(get(content, '[0].lead_in'))} />
                  }
                  {
                    get(content, '[0].body') &&
                    <div className="PageTextSection_body" dangerouslySetInnerHTML={SanitizeHtml(get(content, '[0].body'))} />
                  }
                </div>
              </div>
            </div>
          </div>
        </div>
      }
    </div>
  );
}

PageTextSection.propTypes = {
  content: PropTypes.arrayOf(PropTypes.object).isRequired,
};

PageTextSection.defaultProps = {
};

export default PageTextSection;



// WEBPACK FOOTER //
// ./src/components/PageLoader/Sections/PageTextSection.section.js